module.exports = __webpack_public_path__ + "static/img/CR@3x.1c76d1de.jpg";